/* eslint-disable no-self-assign */

const INITIAL_STATE = {}

export default {
  namespace: 'profile',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setProfile(state, { payload }) {
      return { ...state, ...payload }
    },
  },

  effects: {},
}
